export const LEAD_TIME_EXPEDITE_CONTACT_EMAIL = 'sales@mtsolar.us';
export const ECO_BEAM_ORDER_CONTACT_PHONE = '1-844-687-6527';

export const getLeadTimeExpediteMessage = () =>
    `Contact us at ${LEAD_TIME_EXPEDITE_CONTACT_EMAIL} if you would like to expedite your project.`;
